import React, { JSX } from 'react'
import { CheckIcon } from '@heroicons/react/24/outline'

export const SavedNote = ({
  children = 'Saved.',
  testId
}: {
  children?: React.ReactNode
  testId: string
}): JSX.Element => (
  <div
    data-testid={testId}
    className='flex items-start gap-2 rounded-md border border-emerald-500/30 bg-emerald-500/10 p-3 text-xs text-emerald-300'
  >
    <CheckIcon className='size-4 shrink-0' aria-hidden='true' />
    <span className='flex-1'>{children}</span>
  </div>
)
